export function isSimilarStringLocaleCompare(string1: string, string2: string) {
  return string1.localeCompare(string2, 'pt-BR', { sensitivity: 'base' }) === 0;
}
